/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportForStbGroupsResponseElements,
    ReportForStbGroupsResponseElementsFromJSON,
    ReportForStbGroupsResponseElementsFromJSONTyped,
    ReportForStbGroupsResponseElementsToJSON,
} from './ReportForStbGroupsResponseElements';

/**
 * 
 * @export
 * @interface ReportForStbGroupsResponse
 */
export interface ReportForStbGroupsResponse {
    /**
     * 
     * @type {Array<ReportForStbGroupsResponseElements>}
     * @memberof ReportForStbGroupsResponse
     */
    elements: Array<ReportForStbGroupsResponseElements> | null;
}

export function ReportForStbGroupsResponseFromJSON(json: any): ReportForStbGroupsResponse {
    return ReportForStbGroupsResponseFromJSONTyped(json, false);
}

export function ReportForStbGroupsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForStbGroupsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': (json['elements'] === null ? null : (json['elements'] as Array<any>).map(ReportForStbGroupsResponseElementsFromJSON)),
    };
}

export function ReportForStbGroupsResponseToJSON(value?: ReportForStbGroupsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': (value.elements === null ? null : (value.elements as Array<any>).map(ReportForStbGroupsResponseElementsToJSON)),
    };
}

